import { EXPORT_TEMPLATES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/export_templates_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'exportTemplatesDropdown',
	'exportTemplatesPinned',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
